<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>{{TitleHeader}}</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono nuevo integrador"
              src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Contratistas_Icon@3x.png"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{TitleHeader}}
        </div>
        <!--/Card image-->
        <!--Card content-->
        <mdb-card-body>
          <form id="form2" class="needs-validation" novalidate @submit="checkFormIntegrator">
            <mdb-row class="form-row">
              <!--Form content-->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Datos del registro</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="firtsName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="firstName"
                        required
                        placeholder="Nombre"
                        maxlength="64"
                        v-model="form.firstName"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce un nombre</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="lastName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Apellidos</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="lastName"
                        required
                        placeholder="Apellidos"
                        maxlength="64"
                        v-model="form.lastName"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce un apellido</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="email"
                        style="font-family: OpenSans-Semibold; font-size: 12px; width: 100%;"
                      >Correo electrónico</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="email"
                        required
                        pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        placeholder="Correo electrónico"
                        maxlength="64"
                        v-model="form.email"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div
                        class="invalid-feedback"
                      >Por favor, introduzca un correo con formato email@example.com</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="phone"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Teléfono</label>
                      <input
                        type="number"
                        required
                        class="form-control text-input"
                        id="phone"
                        placeholder="Teléfono del integrador"
                        maxlength="10"
                        v-model="form.phone"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce un Teléfono</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="cp"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Código postal</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="cp"
                        placeholder="Código postal"
                        maxlength="5"
                        v-model="form.CodeP"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                        @keyup="getAddressInformation"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce el código postal</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="city"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Ciudad</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="city"
                        placeholder="Ciudad"
                        maxlength="20"
                        v-model="form.city"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                        disabled
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="state"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Estado</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="state"
                        placeholder="Estado"
                        maxlength="20"
                        v-model="form.state"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                        disabled
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Colonia</label>
                      <model-select
                        :options="colonyList"
                        v-model="colonyModel"
                        style="height: 37px;"
                        placeholder="Selecciona una colonia"
                        :isError="colonyValid"
                      ></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="street"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Calle</label>
                      <input
                        type="text"
                        required
                        class="form-control text-input"
                        id="street"
                        placeholder="Calle"
                        v-model="form.street"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce una calle</div>
                    </div>
                  </mdb-col>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Número exterior</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="number"
                        required
                        placeholder="Número exterior"
                        maxlength="8"
                        v-model="form.numExt"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, introduce un número exterior</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Número interior</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="number"
                        placeholder="Número interior"
                        maxlength="8"
                        v-model="numeroInterior"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold;">Cantidad de licencias</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="number"
                        required
                        placeholder="Cantidad de licencias"
                        maxlength="8"
                        v-model="form.licenses"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">Por favor, debes asignar un numero de licencias</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11"></mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row class="form-row">
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group"></div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row style="padding-left: 35%">
              <mdb-col md="2">
                <button
                  type="button"
                  class="waves-effect waves-dark btn btn-next btn-color-prev"
                  @click="remove()"
                >Cancelar</button>
              </mdb-col>
              <mdb-col md="2">
                <mdb-btn
                  type="submit"
                  class="waves-effect waves-dark btn btn-next btn-color-next"
                >{{TextButton}}</mdb-btn>
              </mdb-col>
              <!--Buttons content-->
            </mdb-row>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
  </mdb-container>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import {
  mdbContainer,
  mdbTooltip,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";

export default {
  name: "New integrator",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    ModelSelect
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      TextButton: "Registrar",
      TitleHeader: "Alta integrador",
      form: {
        firstName: "",
        lastName: "",
        email: "",
        numExt: "",
        CodeP: "",
        phone: "",
        street: "",
        licenses: "",
        city: "",
        state: ""
      },
      numeroInterior: "",
      colonyList: [],
      colonyModel: {
        value: "",
        uuid: "",
        text: ""
      },
      colonyValid: false
    }; // END RETURN
  },
  methods: {
    getAddressInformation() {
      if (this.form.CodeP.length == 5) {
        let aux = this;
        Axios.get(Servers.serverApi + "api/addresses/" + aux.form.CodeP, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        })
          .then(function(response) {
            aux.form.state = response.data[0].state;
            aux.form.city = response.data[0].location;
            aux.colonyList = [];
            for (var i = 0; i < response.data.length; i++) {
              var temp = {
                value: response.data[i].idAddress,
                uuid: response.data[i].uuid,
                text: response.data[i].colony
              };
              aux.colonyList.push(temp);
            }
          })
          .catch(function(error) {
            console.log(error.response.data);
          });
      }
    },
    getOneIntegrator() {
      
      if (this.isEdit) {
        this.TextButton = "Guardar";
        this.TitleHeader = "Editar integrador";
        this.form.firstName = this.IntegratorValue.name
        this.form.lastName = this.IntegratorValue.lastName
        this.form.email = this.IntegratorValue.testUser.email
        this.form.numExt = this.IntegratorValue.number
        this.form.CodeP = this.IntegratorValue.address.cp
        this.getAddressInformation()
        this.form.phone = this.IntegratorValue.phone
        this.form.street = this.IntegratorValue.street
        this.form.licenses = this.IntegratorValue.licenses
        this.form.city = this.IntegratorValue.address.city
        this.form.state = this.IntegratorValue.address.state
        this.numeroInterior = this.IntegratorValue.intNumber
        this.colonyValid = false;
        this.colonyModel.value = this.IntegratorValue.address.idAddress
        this.colonyModel.uuid = this.IntegratorValue.address.uuid
        this.colonyModel.text = this.IntegratorValue.address.colony
      }
    },
    remove() {
      var obj = [];
      this.$store.commit('setResident', obj);
      this.$store.commit('setEditResident', false);
      window.location.href = "/integrators";
    },
    cleanForm() {},
    validateForm(form) {
      return (
        Object.keys(form).length ===
        Object.keys(form).filter(key => form[key].length > 0).length
      );
    },
    checkFormIntegrator(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      var valid = this.validateForm(this.form);

      if (this.colonyModel.value) {
        this.colonyValid = false;
      } else {
        this.colonyValid = true;
      }
     console.log(valid)
      if (!this.colonyValid && valid) {
        if (this.isEdit) {
          this.putIntegrator();
        } else {
          this.postIntegrator();
        }
      }
    },

    putIntegrator() {
      let aux = this;
      var uuid = this.IntegratorValue.uuid;

      var data = {
        name: aux.form.firstName,
        lastName: aux.form.lastName,
        number: aux.form.numExt,
        licenses: aux.form.licenses,
        idAddress: aux.colonyModel.value,
        street: aux.form.street,
        intNumber: aux.numeroInterior,
        phone: aux.form.phone,
        user: {
          idUser: null,
          uuid: null,
          email: aux.form.email,
          firstName: aux.form.firstName,
          lastName: aux.form.lastName,
          status: "ACTIVE",
          idUsersTypes: 14
        }
      };
      
      Axios.put(Servers.serverApi + "api/integrator/" + uuid, data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("Integrador actualizado correctamente");
        })
        .catch(error => {
          aux.showMessageError("No se pudo actualizar", "");
          console.log(error.response.data);
        });
    },
    postIntegrator() {
      let aux = this;
      var data = {
        name: aux.form.firstName,
        lastName: aux.form.lastName,
        number: aux.form.numExt,
        licenses: aux.form.licenses,
        idAddress: aux.colonyModel.value,
        street: aux.form.street,
        intNumber: aux.numeroInterior,
        phone: aux.form.phone,
        user: {
          idUser: null,
          uuid: null,
          email: aux.form.email,
          firstName: aux.form.firstName,
          lastName: aux.form.lastName,
          status: "ACTIVE",
          idUsersTypes: 14
        }
      };
      Axios.post(Servers.serverApi + "api/integrator", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("Integrador  creado correctamente", "Codigo de accesso: "+response.data.user.oldPassword);
        })
        .catch(error => {
          console.log(error.response.data)
           aux.showMessageError("No es posible registrar al integrador", error.response.data.error_description);
        });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text, subtitle) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>"+text+"</span>",
        html: "<span style='font-size: 12px;'>" + subtitle + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          this.remove();
        }
      });
    },
  },
   created() {
         this.getOneIntegrator();
    },
    mounted() {
    
    },
    watch: {
      colonyModel(newColony) {
        this.colonyModel = newColony;
        if (newColony.value) {
          this.colonyValid = false;
        } else {
          this.colonyModel = true;
        }
      }
    },
    computed: {

      isEdit() {
        return this.$store.state.re.edit;
      },
      IntegratorValue() {
        return this.$store.state.re.residentObjet;
      }
    }
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.Datos-del-registro {
  width: auto;
  height: 19px;
  font-family: OpenSans-Bold;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.btn.btn-edit {
  padding: 0.2rem 0.4rem;
  font-size: 0.64rem;
  border-radius: 7px;
  width: 24px;
  height: 23p;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100px;
  outline: none;
  opacity: 0;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

.Rectangle-536 {
  width: 190px;
  height: 37px;
  border-radius: 4px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-1673 {
  width: 161.6px !important;
  height: 37px !important;
  border-radius: 3px !important;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-650 {
  width: 1112.7px;
  height: 500.8px;
  border-radius: 25px;
  border: solid 2px #bce0fd;
  background-color: #ffffff;
}

.save-btn {
  font-size: 10px;
  float: right;
}

.text-width {
  width: auto;
}

.text-input {
  width: auto;
}

.btn-next {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-prev {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-final {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-color-next {
  background-color: #23a7ed !important;
  color: #fff !important;
}

.btn-color-prev {
  background-color: #ed5f5f !important;
  color: #fff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #d33 !important;
  font-size: 12px !important;
}

.btn-modal-download {
  height: 50% !important;
  width: auto !important;
  background-color: #a4a8ab !important;
  font-size: 12px !important;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}

.modal-header {
  background-color: #67a3cf;
  margin-bottom: 20px;
  margin-top: -20px;
}
</style>
<style scoped>
.inputPhone > input:first-child {
  height: 37px !important;
}
</style>
